import styled from 'styled-components'
import FrameBox from '../FrameBox'

export const Box = styled(FrameBox)`
  top: 20px;
  left: 50%;
  transition: all 0.25s ease-in-out;
`

export const Description = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 38px;
`

export const DescriptionText = styled.span`
  display: inline-block;
  white-space: nowrap;
  font-size: 14px;
`



// WEBPACK FOOTER //
// ./src/components/FrameSettings/theme.js